import React from "react";
import "./sequencesummary.css";

class SequenceSummary extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            activeTab: "A",

            textA:
                props.valuesA && props.valuesA.text
                    ? props.valuesA.text
                    : "",

            textB:
                props.valuesB && props.valuesB.text
                    ? props.valuesB.text
                    : ""
        };

        this.handleTextAChange =
            this.handleTextAChange.bind(this);

        this.handleTextBChange =
            this.handleTextBChange.bind(this);

        this.selectTab =
            this.selectTab.bind(this);
    }


    componentDidUpdate(prevProps)
    {
        /*
         * Permet de resynchroniser le composant
         * si le parent lui fournit de nouvelles valeurs.
         */
        if (
            prevProps.valuesA !== this.props.valuesA ||
            prevProps.valuesB !== this.props.valuesB
        )
        {
            const newTextA =
                this.props.valuesA &&
                this.props.valuesA.text
                    ? this.props.valuesA.text
                    : "";

            const newTextB =
                this.props.valuesB &&
                this.props.valuesB.text
                    ? this.props.valuesB.text
                    : "";

            if (
                newTextA !== this.state.textA ||
                newTextB !== this.state.textB
            )
            {
                this.setState({
                    textA: newTextA,
                    textB: newTextB
                });
            }
        }
    }


    notifyChange(textA, textB)
    {
        if (this.props.onChange)
        {
            this.props.onChange({
                A: {
                    ...this.props.valuesA,
                    text: textA
                },

                B: {
                    ...this.props.valuesB,
                    text: textB
                }
            });
        }
    }


    handleTextAChange(event)
    {
        const value = event.target.value;

        this.setState({
            textA: value
        });

        this.notifyChange(
            value,
            this.state.textB
        );
    }


    handleTextBChange(event)
    {
        const value = event.target.value;

        this.setState({
            textB: value
        });

        this.notifyChange(
            this.state.textA,
            value
        );
    }


    selectTab(tab)
    {
        this.setState({
            activeTab: tab
        });
    }


    renderTab(tab, values)
    {
        const active =
            this.state.activeTab === tab;

        const image =
            values && values.img
                ? values.img
                : null;

        const title =
            values && values.title
                ? values.title
                : "";

        return (
            <div
                className={
                    "sequence-summary-tab" +
                    (active ? " active" : "")
                }
                onClick={() => this.selectTab(tab)}
            >
                {image && (
                    <img
                        src={image}
                        alt=""
                        className="sequence-summary-tab-image"
                    />
                )}

                <span>
                    {title}
                </span>
            </div>
        );
    }


    render()
    {
        const valuesA =
            this.props.valuesA || {};

        const valuesB =
            this.props.valuesB || {};

        const isA =
            this.state.activeTab === "A";

        const values =
            isA
                ? valuesA
                : valuesB;

        const text =
            isA
                ? this.state.textA
                : this.state.textB;

        const maxChar =
            values.maxChar == null
                ? 0
                : values.maxChar;

        return (
            <div className="sequence-summary">

                {/* =========================
                    Onglets
                   ========================= */}

                <div className="sequence-summary-tabs">

                    {this.renderTab(
                        "A",
                        valuesA
                    )}

                    {this.renderTab(
                        "B",
                        valuesB
                    )}

                </div>


                {/* =========================
                    Zone de saisie
                   ========================= */}

                <div className="sequence-summary-editor">

                    <textarea
                        value={text}
                        maxLength={maxChar}
                        onKeyDown={ e=> e.stopPropagation()}
                        onChange={
                            isA
                                ? this.handleTextAChange
                                : this.handleTextBChange
                        }
                    />

                    <div className="sequence-summary-counter">
                        {text.length} / {maxChar}
                    </div>

                </div>

            </div>
        );
    }
}


export default SequenceSummary;